import React from 'react';
import { StyleSheet, View, TouchableOpacity, Text } from 'react-native';
import { Header as HeaderRNE, useTheme } from '@rneui/themed';
import { AntDesign } from '@expo/vector-icons';
import { useLanguage } from 'context/LanguageContext';
import LanguageSelect from './select/LanguageSelect';
import { ScreenSizeContext } from 'context/ScreenSizeContext';
import { getHeaderTitle } from 'utils/header';

interface Props {
  title?: string;
  back: any;
  navigation: any;
}

const Header: React.FC<Props> = ({ title, back, navigation }) => {
  const dimensions = React.useContext(ScreenSizeContext);
  const { theme } = useTheme();
  const { currentLanguage, changeLanguage } = useLanguage();
  const resolvedTitle = title ?? getHeaderTitle(currentLanguage);

  return (
    <HeaderRNE
      containerStyle={styles.headerContainer}
      leftContainerStyle={styles.leftContainer}
      centerContainerStyle={styles.centerContainer}
      rightContainerStyle={styles.rightContainer}
      leftComponent={
        back && (
          <TouchableOpacity onPress={navigation.goBack}>
            <AntDesign name="back" size={24} color="black" />
          </TouchableOpacity>
        )
      }
      centerComponent={
        <View style={styles.centerWrapper}>
          <Text
            style={[styles.heading, { color: theme.colors.text }]}
            numberOfLines={3}
          >
            {resolvedTitle}
          </Text>
        </View>
      }
      rightComponent={
        <LanguageSelect
          value={currentLanguage}
          handleChangeLanguage={(lang: string) => {
            void changeLanguage(lang);
          }}
          languageList={['en', 'ja']}
          style={{
            selectArea: {
              width: dimensions.window.width > 600 ? 100 : 60,
            },
            boxStyle: {
              width: dimensions.window.width > 600 ? 100 : 60,
            },
            inputStyle: {
              width: dimensions.window.width > 600 ? 100 : 60,
            },
            dropdownStyle: {
              width: dimensions.window.width > 600 ? 100 : 60,
            },
            dropdownTextStyle: {
              width: dimensions.window.width > 600 ? 100 : 60,
            },
          }}
        />
      }
    />
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    borderBottomWidth: 1,
    borderBottomColor: '#cfcfcf',
  },
  leftContainer: {
    flex: 0.1,
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  centerContainer: {
    flex: 0.7,
    alignItems: 'center',
    justifyContent: 'center',
  },
  rightContainer: {
    flex: 0.2,
    alignItems: 'flex-end',
    justifyContent: 'center',
    paddingRight: 10,
  },
  centerWrapper: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  heading: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center',
    flexWrap: 'wrap',
  },
});

export default Header;
